var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{ref:"imgRef",class:_vm.imgClass,style:(_vm.imgStyle),attrs:{"id":_vm.imgId,"src":_vm.img_src},on:{"click":_vm.click,"load":_vm.onImgLoad}})
}
var staticRenderFns = []

export { render, staticRenderFns }